export default __webpack_public_path__ + "static/brcc-full-width-4-95910e9ed8173f9c021a8f4b29702ee4.avif";